export const version: string = '0.0.1';
